import MuiAccordionDetails, {
  AccordionDetailsProps
} from '@mui/material/AccordionDetails';

export interface IAccordionDetailsProps extends AccordionDetailsProps {}

const AccordionDetails = (props: IAccordionDetailsProps): JSX.Element => {
  return <MuiAccordionDetails {...props} />;
};

export default AccordionDetails;
